import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  testResult: {},
  testAnalysis: {},
  testSolution: {},
  testOMR: {},
  isLoggedIn: false,
};

export const performanceAnalysisReducer = createReducer(initialState, {
  [types.PERFORMANCE_ANALYSIS](state, action) {
    return {
      ...state,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.TEST_RESULT](state, action) {
    return {
      ...state,
      testResult: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.TEST_ANALYSIS_PAPER_1](state, action) {
    return {
      ...state,
      testAnalysis: {
        ...state.testAnalysis,
        paper1: action.response.data,
      },
      errorMessage: action.response.message,
    };
  },
  [types.TEST_ANALYSIS_PAPER_2](state, action) {
    return {
      ...state,
      testAnalysis: {
        ...state.testAnalysis,
        paper2: action.response.data,
      },
      errorMessage: action.response.message,
    };
  },
  [types.TEST_SOLUTION_PAPER_1](state, action) {
    return {
      ...state,
      testSolution: {
        ...state.testSolution,
        paper1: action.response.data,
      },
      errorMessage: action.response.message,
    };
  },
  [types.TEST_SOLUTION_PAPER_2](state, action) {
    return {
      ...state,
      testSolution: {
        ...state.testSolution,
        paper2: action.response.data,
      },
      errorMessage: action.response.message,
    };
  },
  [types.TEST_OMR_1](state, action) {
    return {
      ...state,
      testOMR: {
        ...state.testOMR,
        paper1: action.response.data,
      },
      errorMessage: action.response.message,
    };
  },
  [types.TEST_OMR_2](state, action) {
    return {
      ...state,
      testOMR: {
        ...state.testOMR,
        paper2: action.response.data,
      },
      errorMessage: action.response.message,
    };
  },

  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
